/** @format */
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';

import { Author } from '@toucan/common/contentful/types';

import { MarketContext } from '@toucan/client/global/market';

import { getAuthorPageSlug } from '../../helpers/author';

export type UseAuthorPagePathReturn = {
    route: string;
    path: string;
} | null;

export const useAuthorPagePath = (
    author: Pick<Author, 'linkedFrom'> | null | undefined
): UseAuthorPagePathReturn => {
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    const pageSlug = author ? getAuthorPageSlug(author) : null;

    if (!pageSlug) return null;

    const contentSlug = t('content', { ns: 'urls' });
    const authorsSlug = t('authors', { ns: 'urls' });

    return {
        route: `/content/authors/${pageSlug}`,
        path: `/${activeMarket.slug}/${contentSlug}/${authorsSlug}/${pageSlug}`,
    };
};
